/**
 * Storefront API can return nodes: [null] when a variant exists in the Online Store
 * but is not published to the Headless / app sales channel used by the Storefront token.
 * addToCart in main.js does if (nodes.length > 0) { const c = nodes[0]; ... c.availableForSale }
 * which throws when nodes[0] is null. Filtering nulls makes length 0 so stock check is skipped
 * and /cart/add.js proceeds (same as products fully visible to the API).
 */
(function () {
  var original = window.fetchStoreFront;
  if (typeof original !== 'function') return;

  window.fetchStoreFront = async function fetchStoreFrontPatched() {
    var data = await original.apply(this, arguments);
    if (!data || typeof data !== 'object' || !Array.isArray(data.nodes)) return data;
    var nodes = data.nodes;
    var filtered = nodes.filter(Boolean);
    if (filtered.length === nodes.length) return data;
    return Object.assign({}, data, { nodes: filtered });
  };
})();
